import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import platform from 'rangeConfig/shared/utils/platform';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';

const categories = {
  desktop: [
    {
      id: 'frameWhite',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_DESK },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'design', value: ProductDesign.WHITE }
      ]
    },
    {
      id: 'frameWhiteStainedOak',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_DESK },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'design', value: ProductDesign.WHITE_STAINED_OAK }
      ]
    },
    {
      id: 'frameGreyStainedWalnut',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_DESK },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'design', value: ProductDesign.WALNUT_EFFECT_LIGHT_GREY }
      ]
    },
    {
      id: 'frameHighGlossWhite',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_DESK },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'design', value: ProductDesign.HIGH_GLOSS_WHITE }
      ]
    },
    {
      id: 'frameGreyWoodEffect',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_DESK },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'design', value: ProductDesign.GREY_WOOD_EFFECT }
      ]
    },
    {
      id: 'frameDarkGreen',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_DESK },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'design', value: ProductDesign.DARK_GREEN }
      ]
    },
    {
      id: 'frameBlackBrown',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_DESK },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'design', value: ProductDesign.BLACK_BROWN }
      ]
    }
  ],
  mobile: [
    {
      id: 'frames',
      products: [
        { path: 'type', value: ProductType.KALLAX_FRAME },
        { path: 'type', value: ProductType.KALLAX_TV_BENCH },
        { path: 'type', value: ProductType.KALLAX_DESK }
      ]
    }
  ]
};
const framesProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  categories: categories[platform],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  productFilters: [],
  cluster: ['globalItemNo'],
  sortOrder: [{ path: 'dimensions.width' }, { path: 'dimensions.height' }],
  productCardIcon: getProductCardIconWithTooltip
};

export default framesProductListConfig;
